import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20soft%20illustration%20of%20a%20mother%20gently%20breastfeeding%20her%20baby%20in%20a%20cozy%20sunlit%20room%2C%20Japanese%20manga%20art%20style%2C%20soft%20pastel%20pink%20cream%20and%20warm%20beige%20tones%2C%20dreamy%20atmosphere%20with%20floating%20hearts%20and%20soft%20bokeh%2C%20clean%20minimal%20background%2C%20tender%20motherhood%20scene%2C%20gentle%20lighting&width=1800&height=800&seq=hero-bg-2025&orientation=landscape"
        alt="奶水漫画 - 母婴哺乳主题漫画合集"
        className="absolute inset-0 w-full h-full object-cover"
        title="奶水漫画 母乳喂养漫画 哺乳日常漫画"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 leading-tight" style={{ fontFamily: 'var(--font-heading)' }}>
            用漫画记录哺乳时光
          </h1>
          <p className="text-base md:text-lg text-white/90 mb-8 md:mb-10 leading-relaxed max-w-2xl mx-auto">
            精选母婴哺乳主题原创漫画合集，以温馨幽默的画风呈现新手妈妈哺乳日常、
            母乳喂养知识与亲子互动故事，让每一位妈妈在轻松阅读中获得共鸣与实用育儿指引
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/breastfeeding-daily"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer no-underline transition-all duration-200"
              style={{ backgroundColor: 'oklch(var(--accent-500))', color: '#fff' }}
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-book-open-line text-sm"></i>
              </span>
              开始阅读漫画
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer no-underline border border-white/50 text-white hover:bg-white/10 transition-all duration-200"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <span className="w-6 h-6 flex items-center justify-center text-white/60">
          <i className="ri-arrow-down-s-line text-xl"></i>
        </span>
      </div>
    </section>
  );
}